import * as React from "react";
import { Link } from "react-router-dom";
import { NavItem, NavLink } from 'reactstrap';
import { MEMBERS_PORTAL } from "../../../accounts/Consts";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { setCurrentPage, toggleTopMenuIsActive } from "../../../redux/reducers/HomeReducer";
import { FormatFields } from "../../../redux/types/FormatFields";
import { IEnableModulesConfigurationParametersItem } from "../../../redux/types/IEnableModulesConfigurationParameterItem";
import { IJobState } from "../../../redux/types/IJobState";
import IMembersPortalComponentDataItem from "../../../redux/types/IMembersPortalComponentDataItem";
import { ITabReduxItem } from "../../../redux/types/ITabReduxItem";
import { CLEAR_CACHE, JOBS_IN_PROGRESS_MODAL, LOGOUT, MEMBERS_PORTAL_ACCOUNT_DETAILS, MEMBERS_PORTAL_MY_ACCOUNT, MY_PACKAGES, MY_PACKAGES_PAGE, REPERTOIRE_PAGE_JOBS, SHORTCUT_KEY_MODAL, SHORTCUTS } from "../../../repertoire/Consts";
import { isNullOrUndefined } from "../../../util/tools";
import { If } from "../../components/If";
import { IMenuItem } from "../../types/IMenuItem";
import { Menu } from "../Menu";
import UserLanguageDropDown from "../UserLanguageDropdown";
import ViewPreferenceDropDown from "../ViewPreferenceDropDown";
import { AppInsightsService } from "../../../telemetry/services/AppInsightsService";
import { CURRENT_USER_EMAIL_KEY, CURRENT_USER_NAME_KEY } from "../../../redux/services/AccountSessionStorage";

interface IHeaderProps {
    setCurrentPage: typeof setCurrentPage;
    toggleTopMenuIsActive: typeof toggleTopMenuIsActive;
    menuItems: IMenuItem[];
    currentPage: IMenuItem;
    topMenuIsActive: boolean;
    username: string;
    currentViewAsUserName: string;
    isSignedIn: boolean;
    enabledModules?: IEnableModulesConfigurationParametersItem[];
    displayCustomerLogo: boolean;
    getDisplayCustomerLogo: () => void;
    logoAddresses: string[];
    isLogoRequested: boolean;
    portalType: string;
    client: string;
    customer: string;
    addTab: (tab: ITabReduxItem, portalType: string) => void;
    addWork: (lookups: ILookupDictionary, currentUserNumber: string, formats?: FormatFields[]) => void;
    addSetLists: (lookups: ILookupDictionary, currentUserNumber: string) => void;
    addAgreements: (lookups: ILookupDictionary, currentUserNumber: string, isNew?: boolean, draftAgreementsMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem) => void;
    addLivePerformance: (lookups: ILookupDictionary, isNew?: boolean, livePerformanceMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem, formats?: FormatFields[], distributionCode?: string, currentUserNameNumber?: string) => void;
    uploadCueSheets: (currentUserNumber: string) => void;
    currentUserNameNumber?: string;
    lookupValues?: ILookupDictionary;
    showModal: (
        modalContent: string,
        modalComponentInstance: string,
        modalProps: any,
        displayModalCloseButton: boolean,
        title: string
    ) => void;
    clearAppStateAndReinitialize: (
        portalType: string,
        currentUserEmail?: string
    ) => Promise<void>;
    jobs: IJobState[];
}

interface IHeaderState {
    isLoading: boolean
}

export class Header extends React.Component<IHeaderProps, IHeaderState> {
    viewData;
    constructor(props: IHeaderProps) {
        super(props);
        this.state = {
            isLoading: true
        }
    }

    updateHeader = (menuItem: IMenuItem) => {
        this.props.setCurrentPage(menuItem.link);

        document.title = menuItem.label;
    };

    componentDidMount() {
        const { menuItems, portalType } = this.props;

        if (portalType === MEMBERS_PORTAL) {
            this.setState(() => ({ isLoading: true }));
            localStorage.setItem('portalType', portalType);
        }
        
        document.title = portalType === MEMBERS_PORTAL ? "Members Portal" : "Matching Engine";

        if (menuItems && menuItems.length > 0) {
            this.setState(() => ({ isLoading: false }));
        }
    }

    refreshCache = async (e?: React.MouseEvent<HTMLAnchorElement>): Promise<void> => {
        e?.preventDefault();
        const {
            clearAppStateAndReinitialize,
            portalType
        } = this.props;
        const currentUserEmail = sessionStorage.getItem(CURRENT_USER_EMAIL_KEY) || undefined;
        const originalPath = window.location.pathname;

        try {
            if (originalPath !== "/") {
                window.history.pushState({}, "", "/");
                window.dispatchEvent(new PopStateEvent("popstate"));
            }
            await clearAppStateAndReinitialize(portalType, currentUserEmail);
        } catch (error) {
            AppInsightsService.trackException(error, {
                properties: {
                    action: "refreshCache",
                    portalType,
                    path: originalPath,
                    hasCurrentUserEmail: !!currentUserEmail,
                },
            });
            console.error("refreshCache failed:", error);
        }
    }

    handleAddTab = () => {
        const { addTab, portalType } = this.props;
        let currentPage: IMenuItem;
        const linkString = portalType === MEMBERS_PORTAL ? '/members/myPackages' : '/repertoire/myPackages';
        currentPage = {
            name: 'myPackages',
            icon: 'icon ms-Icon ms-Icon--CubeShape',
            children: [],
            isEnabled: false,
            label: 'My Packages',
            link: linkString,
            pageHeader: 'null',
            portalType: portalType,
            isNavBarEnabled: true
        }

        const META_DATA_KEY: any = {
            'mypackages': { 'tab': MY_PACKAGES_PAGE, instance: portalType }
        }

        this.updateHeader(currentPage);

        if (META_DATA_KEY[currentPage.name.toLowerCase()])
            addTab(META_DATA_KEY[currentPage.name.toLowerCase()].tab, portalType);
    };

    componentDidUpdate(prevProps: IHeaderProps) {
        const { menuItems, portalType } = this.props;

        if (prevProps.menuItems !== menuItems && menuItems?.length > 0) {
            if (this.state.isLoading) {
                this.setState({ isLoading: false });
            }

            document.title = menuItems.find(
                f => f.name === (portalType === MEMBERS_PORTAL ? 'works' : 'home')
            )?.pageHeader;
        }
    }

    renderHeaderLogo = () => {
        const { portalType, client } = this.props;
        if (portalType) {
            if (portalType === MEMBERS_PORTAL) {
                if (client) {
                    return <img src={`assets/logo-${client.toLowerCase()}.png`} className="MP-header-logo" title="Members Portal" alt="Members Portal" />
                }
                return <img src={`assets/logo-spt.png`} className="MP-header-logo" title="Members Portal" alt="Members Portal" />
            }
            else {
                return <img src="assets/logo-matching-engine.png" title="Spanish Point Technologies" alt="Spanish Point Technologies" />
            }
        }
    }

    processMenuItems(items: IMenuItem[]): IMenuItem[] {
        return items.map(item => {
            let children = item.children ? this.processMenuItems(item.children) : [];
            const hasChildren = children.length > 0;
            const allChildrenDisabled = hasChildren && children.every(child => !child.isEnabled);
            const isEnabled = item.isEnabled && (!hasChildren || !allChildrenDisabled);

            return {
                ...item,
                isEnabled,
                children
            };
        });
    }

    getProcessedMenuItems(menuItems: IMenuItem[], portalType: string, currentUserNameNumber?: string): IMenuItem[] {
        let filtered = menuItems.filter(m => m.link !== '/' && m.link !== null && m.isNavBarEnabled !== false && m.name !== "userDropdownMenu");
        if (portalType === MEMBERS_PORTAL && (isNullOrUndefined(currentUserNameNumber) || /^\s*0+\s*$/.test(String(currentUserNameNumber)))
        ) {
            filtered.forEach(i => {
                if (i.name === "myAccount") i.isEnabled = true;
                else i.children?.forEach(c => c.isEnabled = false);
            });
        }
        return this.processMenuItems(filtered);
    }

    render() {
        if (window.location.pathname === "/aadLogin") {
            return <div className="emptyHeader" />;
        }

        let className: string = "collapse navbar-collapse";
        const {
            currentPage,
            menuItems,
            topMenuIsActive,
            toggleTopMenuIsActive,
            enabledModules,
            displayCustomerLogo,
            logoAddresses,
            getDisplayCustomerLogo,
            isLogoRequested,
            addTab,
            addWork,
            addSetLists,
            addAgreements,
            portalType,
            currentViewAsUserName,
            currentUserNameNumber,
            customer,
            lookupValues,
            showModal,
            jobs,
            addLivePerformance,
            uploadCueSheets
        } = this.props;
        const { isLoading } = this.state;
        const jobsToDisplay = REPERTOIRE_PAGE_JOBS;
        const displayedJobs = jobs && jobs.filter(j => jobsToDisplay.includes(j.type));
        const jobsLength = displayedJobs.length;

        const isSignedInParsed = sessionStorage.getItem('isSignedIn') === 'true';
        const username = sessionStorage.getItem(CURRENT_USER_NAME_KEY)
        const displayName =
            portalType === MEMBERS_PORTAL ? (currentViewAsUserName || username) : username;
        if (!isSignedInParsed || menuItems == null || menuItems == undefined || menuItems.length === 0)
            return <div className="emptyHeader" data-testid="emptyHeader" />;

        if (topMenuIsActive) {
            className = className + " in";
        }

        if (isSignedInParsed && !isLogoRequested) {
            getDisplayCustomerLogo();
        }

        if (customer != undefined) {
            localStorage.setItem('customer', JSON.stringify(customer))
        }

        const showModalShortCutKeys = () => {
            showModal(SHORTCUT_KEY_MODAL, SHORTCUT_KEY_MODAL, null, true, "Shortcuts keys");
        }

        const handleOpenJobsInProgressModal = () => {
            showModal(JOBS_IN_PROGRESS_MODAL, JOBS_IN_PROGRESS_MODAL, currentPage, true, "Jobs in progress");
        }

        const renderJobsInProgressLink = jobsLength && jobsLength >= 1;

        const renderTitleSection = () => {

            if (isNullOrUndefined(currentPage)) {
                return null;
            }
            else {
                return <div className="titleSection flexRow flexJustifyContentSpaceBetween tabBannerSection">
                    <div className="flexRow paddingLeftLarge">
                        <span className={currentPage.icon} aria-hidden="true"></span>
                        <span>{currentPage.pageHeader}</span>
                    </div>
                    <div className="paddingRightLarge">
                        {!!renderJobsInProgressLink && <div className="jobsProgressHeader" onClick={handleOpenJobsInProgressModal}><span className="icon info ms-Icon ms-Icon--SyncStatus"></span><a>{`${jobsLength} Jobs in Progress`}</a></div>}
                    </div>
                </div>
            }
        }

        const filteredMenuItems = this.getProcessedMenuItems(menuItems, portalType, currentUserNameNumber);
        const userMenuDropdown = menuItems.find(m => m.name === "userDropdownMenu");

        if (!isLoading)
            return (
                <header className={`container-full ${portalType ? portalType.toLowerCase() : ''}`}>
                    <nav className="navbar navbar-fixed-top" role="navigation">
                        <div className="container-fluid topSection">

                            {/* Brand and toggle get grouped for better mobile display -->*/}
                            <div className="navbar-header">
                                <button type="button" className="navbar-toggle" data-toggle="collapse"
                                    onClick={toggleTopMenuIsActive}>
                                    <span className="sr-only">Toggle navigation</span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                    <span className="icon-bar"></span>
                                </button>
                                <NavLink tag={Link} className="navbar-brand" to="/">
                                    {this.renderHeaderLogo()}
                                </NavLink>
                            </div>

                            <div className={className}>
                                <If condition={menuItems && menuItems.length > 0}>
                                    <Menu items={filteredMenuItems}
                                        updateHeader={this.updateHeader.bind(this)}
                                        enabledModules={enabledModules}
                                        isMembersPortal={portalType === MEMBERS_PORTAL}
                                        customer={customer}
                                        addTab={(tab) => addTab(tab, portalType)}
                                        currentUserNameNumber={currentUserNameNumber}
                                        lookups={lookupValues}
                                        addWork={addWork}
                                        addAgreements={addAgreements}
                                        addSetLists={addSetLists}
                                        addLivePerformance={addLivePerformance}
                                        uploadCueSheets={uploadCueSheets} />
                                </If>


                                {/* Account & Logo -->*/}
                                <ul className="nav navbar-nav navbar-right">
                                    <ViewPreferenceDropDown menuItems={menuItems} />

                                    <If condition={portalType === MEMBERS_PORTAL}>
                                        <div className="navbar-header">
                                            <UserLanguageDropDown menuItems={menuItems} />
                                        </div>
                                    </If>

                                    {/* Logo -->*/}
                                    <If condition={displayCustomerLogo === true && logoAddresses !== undefined && logoAddresses.length > 0}>
                                        <div id="logo" className="navbar-header">
                                            {logoAddresses.map((address) => {
                                                return (
                                                    <NavLink tag={Link} className="navbar-brand" to="/">
                                                        <img src={address} title="EU" alt="EU" />
                                                    </NavLink>
                                                )
                                            })}
                                        </div>
                                    </If>

                                    {/* User Menu -->*/}
                                    <If condition={!!username
                                        && username.length > 0
                                        && !!(userMenuDropdown && userMenuDropdown.children && userMenuDropdown.children.length > 0)
                                        && portalType === MEMBERS_PORTAL} >
                                        <li className="dropdown">
                                            <NavLink className="dropdown-toggle" tag={Link} to="/">
                                                {username}
                                                <b className="caret" />
                                            </NavLink>
                                            <ul className="dropdown-menu">
                                                {userMenuDropdown.children.map((item) => {
                                                    if (item.name == MEMBERS_PORTAL_MY_ACCOUNT) {
                                                        return (
                                                            <NavItem>
                                                                <NavLink tag={Link} to={item.link}><h3>{item.label}</h3></NavLink>
                                                            </NavItem>
                                                        )
                                                    }
                                                    if (item.name == LOGOUT) {
                                                        return (
                                                            <>
                                                                <hr />
                                                                <NavItem>
                                                                    <NavLink tag={Link} to={item.link}>{item.label}</NavLink>
                                                                </NavItem>
                                                            </>
                                                        )
                                                    }
                                                    if (item.name == MY_PACKAGES) {
                                                        return (
                                                            <NavItem>
                                                                <NavLink tag={Link} onClick={() => this.handleAddTab()} to={item.link}>{item.label}</NavLink>
                                                            </NavItem>
                                                        )
                                                    }
                                                    if (item.name == CLEAR_CACHE) {
                                                        return (
                                                            <li>
                                                                <a href="#" onClick={this.refreshCache}>
                                                                    {item.label}
                                                                </a>
                                                            </li>
                                                        )
                                                    }

                                                    if (item.name == MEMBERS_PORTAL_ACCOUNT_DETAILS) {
                                                        const isDisabled = !item.isEnabled;

                                                        return (
                                                            <NavItem className={isDisabled ? "disabled" : ""}>
                                                                <NavLink
                                                                    tag={Link}
                                                                    to={isDisabled ? "#" : item.link}
                                                                    aria-disabled={isDisabled}
                                                                    className={isDisabled ? "disabled" : ""}
                                                                >
                                                                    {item.label}
                                                                </NavLink>
                                                            </NavItem>
                                                        );
                                                    }

                                                    return (
                                                        <NavItem>
                                                            <NavLink tag={Link} to={item.link}>{item.label}</NavLink>
                                                        </NavItem>
                                                    )
                                                })}
                                            </ul>
                                        </li>
                                    </If>
                                    <If condition={!!username && username.length > 0 && portalType !== MEMBERS_PORTAL}>
                                        <li className="dropdown">
                                            <NavLink className="dropdown-toggle" tag={Link} to="/">
                                                {username}
                                                <b className="caret" />
                                            </NavLink>
                                            <ul className="dropdown-menu">
                                                {userMenuDropdown.children.map((item) => {
                                                    if (item.name == LOGOUT) {
                                                        return (
                                                            <NavItem>
                                                                <NavLink tag={Link} to={item.link}>{item.label}</NavLink>
                                                            </NavItem>
                                                        )
                                                    }
                                                    if (item.name == CLEAR_CACHE) {
                                                        return (
                                                            <NavItem>
                                                                <a href="#" onClick={this.refreshCache}>
                                                                    {item.label}
                                                                </a>
                                                            </NavItem>
                                                        )
                                                    }
                                                    if (item.name == SHORTCUTS) {
                                                        return (
                                                            <NavItem>
                                                                <a onClick={() => showModalShortCutKeys()}>{item.label}</a>
                                                            </NavItem>
                                                        )
                                                    }
                                                    if (item.name == MY_PACKAGES) {
                                                        return (
                                                            <NavItem>
                                                                <NavLink tag={Link} onClick={() => this.handleAddTab()} to={item.link}>{item.label}</NavLink>
                                                            </NavItem>
                                                        )
                                                    }
                                                }
                                                )}
                                            </ul>
                                        </li>
                                    </If>
                                </ul>
                            </div>
                        </div>
                        {renderTitleSection()}
                    </nav>
                </header>
            );
        return <div></div>
    }
}
